import { render, staticRenderFns } from "./group-notifications-edit.vue?vue&type=template&id=719b1b74&scoped=true&"
import script from "./group-notifications-edit.vue?vue&type=script&lang=js&"
export * from "./group-notifications-edit.vue?vue&type=script&lang=js&"
import style0 from "./group-notifications-edit.vue?vue&type=style&index=0&id=719b1b74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b1b74",
  null
  
)

export default component.exports